<template>
  <div class="share-page">
    <div v-if="isWeChat">
      <browser-open></browser-open>
    </div>

    <div v-else>

      <!-- 个人主页背景图 -->
      <div class="page-bg">
        <top-nav :appLink="params.appLink"></top-nav>

        <div style="text-align:center">
          <!-- 头像 -->
          <div class="avatar">
            <van-image round width="100%" height="100%" :src="userInfo.avatarImg" />
          </div>

          <div class="nick-name">{{ userInfo.alias }}</div>

          <!-- ID  -->
          <div class="user-id">
            <span class="text">ID: {{ userInfo.userCode }}</span>
            <span class="down-load" @click="handleCopy(userInfo.userCode)"></span>
          </div>

          <!-- 签名 -->
          <div class="sign">
            {{ userInfo.introduce ? userInfo.introduce : '这个人很懒，什么都没有留下' }}
          </div>

        </div>

      </div>

      <!-- 关注 粉丝 信息 -->
      <div class="card-info">
        <div class="text">
          关注:{{ userInfo.likeCount }} <span style="color:#D1D1D1">&nbsp; ｜ &nbsp;</span> 粉丝:{{ userInfo.fansCount }}
        </div>

        <div class="user-label">
          <div class="lb-xb" style="background: #FFFFFF!important">
            <span class="nan" v-if="userInfo.sex == 1"></span>
            <span class="nv" v-if="userInfo.sex == 0"></span>
            <!-- {{ toAge(1590387792000) }}岁 -->
          </div>
          <div class="lb-xz" v-if="userInfo.birthday">
            <img style="scale:1.9" height="12" :src="getHoroscope(userInfo.birthday).img" alt="">
          </div>
          <!-- <div class="lb-gh">
            {{ userInfo.guildName }}
          </div> -->
        </div>

        <!-- 标签 -->
        <div v-if="userInfo.labels.length > 0" class="personality-label">
          <img width="14" style="width:14px;height:15px" src="/imgs/biaoqian.png" />

          <div class="lbs">
            <div class="d" v-for="(v, i) in userInfo.labels" :key="i">{{ v.label }}</div>
          </div>
        </div>

        <div class="personality-label">
          <img width="14" style="width:14px;height:15px" src="/imgs/location.png" />

          <div class="location">
            来自 {{ userInfo.ipProvince }} · {{ userInfo.ipCity }}
            <!-- 来自 {{ CITY[userInfo.userProvince] }} · {{ CITY[userInfo.userCity] }} -->
          </div>
        </div>

        <!-- 动态 导航 -->

        <div class="tab">
          <div class="text">
            动态
          </div>

          <div class="gyt">
            关于Ta
          </div>
        </div>
      </div>



      <div class="content">
        <dynamic :dynamicData="dynamicData"></dynamic>
      </div>


      <!-- <footer-nav></footer-nav> -->


      <van-tabbar style="height:60px" v-model="active">
        <div style="text-align:center;width:100%;margin-top: 12px;">
          <van-button class="btn" @click="handleOpenApp" round color="#F9EB34">聊一聊</van-button>
        </div>
      </van-tabbar>



    </div>

  </div>
</template>

<script>
import topNav from '../../components/topNav.vue'
import { getUrlParam, isWeChatBrowser } from '../../config/utils'
import { getUserPageInfo, getNewOneH5 } from '../../api/sy'
import { city } from '../../config/city'
import Dynamic from '../../components/dynamic.vue'
import FooterNav from '../../components/footerNav.vue'
import BrowserOpen from './browserOpen.vue';
import { Toast } from 'vant';

export default {
  components: { topNav, Dynamic, FooterNav, BrowserOpen },
  name: 'sharePage',
  data() {
    return {
      dynamicData: {},
      CITY: city,
      userInfo: {
        labels:[]
      },
      isWeChat: isWeChatBrowser(),
      params: {
        id: '',
        appLink: ''
      },
      xzImg: '',
      xzList: [
        {
          name: '摩羯',
          img: '/imgs/mojie.png'
        },
        {
          name: '水瓶',
          img: '/imgs/shuiping.png'
        },
        {
          name: '双鱼',
          img: '/imgs/shuangyu.png'
        },
        {
          name: '白羊',
          img: '/imgs/baiyang.png'
        },
        {
          name: '金牛',
          img: '/imgs/jinniu.png'
        },
        {
          name: '双子',
          img: '/imgs/shuangzi.png'
        },
        {
          name: '巨蟹',
          img: '/imgs/juxie.png'
        },
        {
          name: '狮子',
          img: '/imgs/shizi.png'
        },
        {
          name: '处女',
          img: '/imgs/chunv.png'
        },
        {
          name: '天秤',
          img: '/imgs/tianping.png'
        },
        {
          name: '天蝎',
          img: '/imgs/tianxie.png'
        },
        {
          name: '射手',
          img: '/imgs/sheshou.png'
        },
        {
          name: '摩羯',
          img: '/imgs/mojie.png'
        },
      ],
      timer: ''
    }
  },
  mounted() {
    this.handleUrl()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    handleCopy (data) {
      let oInput = document.createElement("input");
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      Toast('复制成功')
      oInput.remove();

    },
    getHoroscope(date) {
      if (!date) {
        return { img: '' }
      }
      // let c = ['摩羯', '水瓶', '双鱼', '白羊', '金牛', '双子', '巨蟹', '狮子', '处女', '天秤', '天蝎', '射手', '摩羯']
      date = new Date(date * 1000);
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let startMonth = month - (day - 14 < '865778999988'.charAt(month));
      return this.xzList[startMonth];
    },
    // 根据返回的日期计算间隔
    toAge(timeStamp) {
      let birthDate = this.toDate(timeStamp).substr(0, 4);
      let newDate = new Date().getFullYear();
      return (newDate - parseInt(birthDate));
    },
    // 时间戳转日期
    toDate(number) {
      let n = number;
      let date = new Date(n);
      let Y = date.getFullYear() + '/';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return (Y + M + D)
    },
    handleUrl() {
      if (!this.$route.query.appLink) return
      this.params.appLink = this.$Base64.decode(this.$route.query.appLink);
      this.params.id = getUrlParam(this.params.appLink, 'uid');
      this.handleGetUserpageInfo();
      this.handleGetNewOneH5();
    },
    handleGetUserpageInfo() {
      let params = {
        id: this.params.id
      }
      getUserPageInfo(params).then(res => {
        if (res.data.code == 200) {
          this.userInfo = res.data.data;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    handleGetNewOneH5() {
      let params = {
        userId: this.params.id
      }
      getNewOneH5(params).then(res => {
        if (res.data.code == 200) {
          const data = res.data.data
          this.dynamicData = data.dynamicId ? data : {}
        }
      }).catch(err => {
        console.log(err);
      })
    },
    handleOpenApp() {
      if (!this.params.appLink) return;
      window.location.href = this.params.appLink;
      this.timer = setTimeout(()=>{
      if (typeof document.hidden !== "undefined") {
        if (!document.hidden) {
          window.location.href = process.env.VUE_APP_HERF_APPWEB
        }
      } else if (typeof document.mozHidden !== "undefined") {
        if (!document.mozHidden) {
          window.location.href = process.env.VUE_APP_HERF_APPWEB
        }
      } else if (typeof document.msHidden !== "undefined") {
        if (!document.msHidden) {
          window.location.href = process.env.VUE_APP_HERF_APPWEB
        }
      } else if (typeof document.webkitHidden !== "undefined") {
        if (!document.webkitHidden) {
          window.location.href = process.env.VUE_APP_HERF_APPWEB
        }
      }
      },2000)
    }
  }

}
</script>

<style lang="less" scoped>
.share-page {
  .page-bg {
    background: url('/imgs/homepageBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 361px;

    .avatar {
      background: #FFFFFF;
      width: 65px;
      height: 65px;
      margin-top: 53.5px;
      display: inline-block;
      border-radius: 50px;
      border: 1px solid #ffffff;
    }

    .nick-name {
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
      margin-top: 17px;
    }

    .user-id {
      height: 30px;
      border-radius: 56px;
      background-color: rgba(255, 255, 255, 0.6);
      display: inline-block;
      padding: 7px 10px 7px 10px;
      margin-top: 10px;

      .text {
        color: #FFFFFF;
        font-size: 12px;
      }

      .down-load {
        background: url('/imgs/download.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 12px;
        width: 12px;
        display: inline-block;
        margin-left: 5px;
      }
    }

    .sign {
      color: #FFFFFF;
      font-size: 12px;
      margin-top: 22px;
      font-weight: 400;
    }
  }

  .card-info {
    background: #FFFFFF;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-top: -32px;
    padding-top: 19px;
    padding-left: 14px;
    padding-right: 14px;
    padding-bottom: 15px;

    .text {
      font-size: 13px;
      color: #373737;
      font-weight: 500;
    }

    .user-label {
      display: flex;
      margin-top: 13px;
      font-size: 8px;
      color: #FFFFFF;

      .lb-xb {
        border-radius: 30px;
        background: linear-gradient(89deg, #FF67E4 0%, #FE9882 100%);
        padding: 3px 14px 5px 14px;
        min-width: 41px;
        margin-right: 7px;
        font-size: 12px;

        .nv {
          background: url('/imgs/nv.png');
          width: 12px;
          height: 12px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: inline-block;
          position: relative;
          top: 2px;
          left: -4px;
          scale: 1.8;
        }

        .nan {
          background: url('/imgs/nan.png');
          width: 12px;
          height: 12px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: inline-block;
          position: relative;
          top: 2px;
          left: -4px;
          scale: 1.4;
        }
      }

      .lb-xz {
        border-radius: 30px;
        background: linear-gradient(49deg, #9471FF 0%, #D894FF 100%);
        padding: 6px 14px 5px 14px;
        min-width: 41px;
        margin-right: 7px;

      }

      .lb-gh {
        border-radius: 30px;
        background: linear-gradient(91deg, #FFD074 0%, #D62F2D 100%);
        padding: 6px 14px 5px 14px;
        min-width: 41px;
      }


    }

    .personality-label {
      display: flex;
      margin-top: 19px;

      img {
        margin-right: 7px;
      }

      .lbs {
        display: flex;

        .d {
          margin-right: 7px;
          font-size: 12px;
          color: #373737;
        }

        .d:not(:last-child) {
          border-right: 2px solid #D1D1D1;
          height: 14px;
          padding-right: 10px;
        }
      }

      .location {
        font-size: 12px;
        color: #373737;
        line-height: 15px;
      }
    }

    .tab {
      margin-top: 30px;
      display: flex;

      .text {
        font-size: 15px;
        color: #373737;
        font-weight: bold;
        border-bottom: 4px solid #F9EB34;
        width: auto;
      }

      .gyt {
        color: #666666;
        font-size: 15px;
        font-weight: bold;
        margin-left: 30px;
      }
    }


  }

  .content {
    background: #F8F8F8;
    height: auto;
    margin-bottom: 35px;
  }

  .btn {
    width: 340px;
    height: 37px;
    color: #373737 !important;
    font-size: 14px !important;
  }
}
</style>